module.exports = __webpack_public_path__ + "static/media/bp21.0e52c732.jpg";